import { Input, Component, ViewEncapsulation } from '@angular/core';
import { MenuParentNode } from '../menu-nav-bar.model';

@Component({
    selector: 'menu-node',
    templateUrl: './menu-node.component.html',
    styleUrls: ['./menu-node.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MenuNodeComponent {
  @Input('nodes') nodes: Array<MenuParentNode>;
}
